import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class CarCommonModel extends BaseModel {

    constructor() {
        super({
                name: "car_common",
                tableName: 'car_common',
                label: "car_common",
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    display: false
                },
                type: {
                    name: 'type',
                    type: "Number",
                    display: false
                },
            })
    }

}